import { useState } from 'react';
import {
  Button, Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions,
  Field,
} from '@fluentui/react-components';
import { DateInput } from './DateInput';

export interface DateRangeValue {
  from?: string;
  to?: string;
}

interface DateRangeFilterModalProps {
  open: boolean;
  label: string;
  fromLabel: string;
  toLabel: string;
  applyLabel: string;
  clearLabel: string;
  value: DateRangeValue;
  onApply: (value: DateRangeValue) => void;
  onClear: () => void;
  onClose: () => void;
}

/** Modal de rango de fecha para <FilterPanel> — dimensión "Fecha", distinta
 * del patrón checkbox del resto de dimensiones (dos date inputs en vez de
 * una lista). Ver docs/superpowers/specs/2026-09-12-filterpanel-vista-lote-design.md. */
export function DateRangeFilterModal({
  open, label, fromLabel, toLabel, applyLabel, clearLabel, value, onApply, onClear, onClose,
}: DateRangeFilterModalProps) {
  const [from, setFrom] = useState(value.from ?? '');
  const [to, setTo] = useState(value.to ?? '');

  const handleApply = () => {
    onApply({ from: from || undefined, to: to || undefined });
    onClose();
  };

  const handleClear = () => {
    setFrom('');
    setTo('');
    onClear();
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(_, d) => !d.open && onClose()} modalType="modal">
      <DialogSurface style={{ maxWidth: '360px' }}>
        <DialogBody>
          <DialogTitle>{label}</DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingTop: '8px' }}>
              <Field label={fromLabel}>
                <DateInput value={from} onValueChange={(v) => setFrom(v)} />
              </Field>
              <Field label={toLabel}>
                <DateInput value={to} onValueChange={(v) => setTo(v)} />
              </Field>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="subtle" onClick={handleClear}>{clearLabel}</Button>
            <Button appearance="primary" onClick={handleApply}>{applyLabel}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
